import aframe from 'aframe'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import 'aframe-orbit-controls'

import 'materialize-css/dist/css/materialize.min.css';

Vue.config.productionTip = false
Vue.config.ignoredElements = [
  'a-scene',
  'a-entity',
  'a-camera',
  'a-box',
  'a-sky',
  'a-sphere',
  'a-cylinder',
  'a-plane',
  'a-curvedimage',
  'a-image',
  'a-assets',
  'a-mixin'
];


new Vue({
  router,
  render: h => h(App)
}).$mount('#app')


import WebFont from 'webfontloader'

  WebFont.load({
    google: {
      families: ['IM Fell English SC', 'Material Icons', 'Didact+Gothic', 'Major+Mono+Display']
    },
    typekit: {
    id: 'ajc4iiq'
    }
  });
  

aframe.registerComponent('handle-events', {
                
                 init: function() {
                     var el = this.el; 
                     var clicked = false
                     el.addEventListener('click', function() {
                         if (clicked) {
                             el.setAttribute('src', '#pause');
                             
                         }
                         else {
                             el.setAttribute('src', '#play');
                         }
                         clicked = !clicked
                         console.log('clicked')
                     })
                 }
             });
        
  